import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import classnames from 'classnames/bind';
import styles from './productList.module.scss';
import i18n from 'i18n';
import _ from 'lodash';
import { ProductVisibility } from 'core/product/Product';

const cx = classnames.bind(styles);

type NameHeaderProps = {
  productsOfCurrentConditionLength: number;
  selectedProductsOfCurrentCondition: (number | string)[];
  hasSelectedProductsOfOtherCondition: boolean;
  onSelectAll: () => void;
  singleSelect?: boolean;
};

const nameHeaderFormatter = (
  getHeaderProps: () => NameHeaderProps,
  column: any,
  _1,
  { sortElement }
) => {
  const {
    productsOfCurrentConditionLength,
    selectedProductsOfCurrentCondition,
    hasSelectedProductsOfOtherCondition,
    onSelectAll,
    singleSelect
  } = getHeaderProps();
  const checked = productsOfCurrentConditionLength === selectedProductsOfCurrentCondition.length;
  return (
    <div className={styles.nameHeader}>
      {singleSelect ? (
        // keep the checkbox's reserved space so the header stays aligned with the rows
        <div className={styles.selectCheckBox} />
      ) : (
        <div className={styles.selectCheckBox}>
          <input
            type='checkbox'
            checked={checked}
            ref={element => element && (
              element.indeterminate = (hasSelectedProductsOfOtherCondition && selectedProductsOfCurrentCondition.length === 0) ||
                (!checked && selectedProductsOfCurrentCondition.length > 0)
            )}
            onChange={onSelectAll}
            id={'inputAll'}
          />
          <label htmlFor='inputAll' />
        </div>
      )}
      {i18n.t<string>(column.text)}
      {sortElement}
    </div>
  );
};

const nameFormatter = (productId: any, product, _2, formatExtraData: any): any => {
  const { selectedProducts, onSelect } = formatExtraData;
  const isHidden = product.visibility === ProductVisibility.HIDDEN;
  const isSelected = selectedProducts.indexOf(productId.toString()) > -1;
  const nameCellClassName = cx('nameCell', { hidden: isHidden });
  // Hidden products can only be deselected (removed), not selected
  const isDisabled = isHidden && !isSelected;

  const checkbox = (
    <div className={styles.selectCheckBox}>
      <input
        type='checkbox'
        checked={isSelected}
        onChange={_.partial(onSelect, productId.toString())}
        id={`input${productId}`}
        disabled={isDisabled}
      />
      <label htmlFor={`input${productId}`} />
    </div>
  );

  return (
    <div className={nameCellClassName}>
      {isHidden ? (
        <OverlayTrigger
          placement='top-start'
          trigger={['hover', 'focus']}
          overlay={
            <Tooltip
              id={`hidden-product-tooltip-${productId}`}
              className={styles.hiddenProductTooltip}
            >
              {i18n.t<string>('productList.labels.hiddenProductTip')}
            </Tooltip>
          }
        >
          {checkbox}
        </OverlayTrigger>
      ) : checkbox}
      <div className={styles.info}>
        <div className={styles.name}>
          {product.name}
        </div>
        <div className={styles.id}>
          {'ID: ' + productId}
        </div>
      </div>
    </div>
  );
};

const imageFormatter = (imageData: any) => {
  if (!imageData) {
    return <div />;
  }

  return (
    <div className={styles.imgCell}>
      <div className={styles.imgPreview}>
        <img src={imageData} alt={'product img detail'} />
      </div>
    </div>
  );
};

const formatters = {
  nameHeaderFormatter,
  nameFormatter,
  imageFormatter
};
export default formatters;
